import type { FC, ReactNode } from 'react'

interface MonogramProps {
    className?: string
    title?: string
}

/* The roofline mark from the official Capital Craft Construction logo,
   extracted as a standalone shape for decorative watermark use (footer,
   CTA bands). Single flat fill via currentColor, matching the brand pack. */
export const Monogram: FC<MonogramProps> = ({ className, title }): ReactNode => {
    return (
        <svg
            viewBox='0 0 256.78 190.49'
            className={className}
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            focusable='false'
        >
            {title ? <title>{title}</title> : null}

            <g fill='currentColor'>
                <polygon points='256.78 0 91.11 95.24 91.11 190.49 0 190.49 0 50.21 87.33 0 256.78 0' />
                <polygon points='139.46 190.49 256.78 190.49 256.78 113.71 139.46 190.49' />
            </g>
        </svg>
    )
}
